// The one door to `new maplibregl.Map` (docs/MAPS.md § The controller): the
// two things MapLibre 6 asks of a bundle.
//
// `maplibregl` is the module the caller imported on connect: this file never
// imports it, so no page that draws no map ever fetches it.
//
//   worker  a module file with a chunk of its own, which no bundle finds by
//           itself. The host builds it and its head names it (`maplibre-worker`,
//           HeadHelper); no meta, the library's own guess.
//   webgl2  no context, no map: `null`, and the caller draws the page without
//           one. Any other error is a bug and goes up.
export function open(maplibregl, options) {
  const worker = document.querySelector('meta[name="maplibre-worker"]')?.content;
  if (worker) maplibregl.setWorkerUrl(worker);

  try {
    return new maplibregl.Map(options);
  } catch (error) {
    if (error instanceof maplibregl.GPUInitializationError) return null;
    throw error;
  }
}
